import { Navigate, Outlet } from "react-router-dom";
function ProtectedRoute() {
  if (localStorage.AuthKey && localStorage.AuthKey.length > 0)
    return <Outlet />;
  else return <Navigate to="/" />;
}
export default ProtectedRoute;
